import Layout from '@/layout'

const route = {
  path: '/verification',
  component: Layout,
  redirect: '/verification/index',
  alwaysShow: true, // will always show the root menu
  name: 'Verification',
  meta: {
    title: 'verification',
    icon: 'el-icon-files',
    roles: [
      'larke-admin.verification.index'
    ]
  },
  sort: 110070,
  children: [
    // 扩展管理
    {
      path: '/verification/index',
      component: () => import('@/views/verification/index'),
      name: 'VerificationIndex',
      meta: {
        title: 'verificationIndex',
        icon: 'el-icon-tickets',
        roles: [
          'larke-admin.verification.index'
        ]
      }
    }
  ]
}

export default route
